<template>
  <div v-if="newsData.length" class="centerx">
    <vs-popup class="news-popup" title="" :active.sync="popupActive">
      <div class="w-full relative">
        <VueSlickCarousel :arrows="true" :dots="true" ref="carousel">
          <div v-for="(news, index) in newsData" :key="index">
            <div class="flex justify-center items-center">
              <div class="text-center">
                <h1 class="font-semibold">{{ news.NewsTitle }}</h1>
                <p class="text-lg mt-12 mb-6">{{ news.NewsContent }}</p>
              </div>
            </div>
          </div>
          <template #prevArrow>
            <vs-button color="transparent" @click="prev" class="custom-prev">
              <font-awesome-icon :icon="['fal', 'arrow-left']" />
            </vs-button>
          </template>
          <template #nextArrow>
            <vs-button color="transparent" @click="next" class="custom-next">
              <font-awesome-icon :icon="['fal', 'arrow-right']" />
            </vs-button>
          </template>
        </VueSlickCarousel>
        <div class="flex justify-center mt-4">
          <vs-button color="secondary" class="mx-2" @click="markAsRead">
            <font-awesome-icon :icon="['far', 'eye-slash']" /> <span> {{ $t('MarkAllAsRead') }}</span>
          </vs-button>
          <vs-button class="mx-2" @click="popupActive = false"><font-awesome-icon :icon="['fal', 'times']" /> <span> {{ $t('Close') }}</span></vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// Import VueSlickCarousel component
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: 'NewsPopup',
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      newsData: [],
      popupActive: false,
    };
  },
  computed: {
    applicationPK() {
      const user = this.$store.getters['auth/user'];
      const role = user.company.roles.filter((role) =>
          role.applications[0].ExternalIdentity_Key === process.env.VUE_APP_AUTH0_CLIENT_ID
      );

      return role[0].applications[0].Application_PK;
    },
  },
  async mounted() {
    await this.fetchNewsData();
  },
  methods: {
    async markAsRead() {
      try {
        await this.$api.news.markNewsAsRead(this.applicationPK);
        this.popupActive = false;
      } catch (e) {
        console.log(e);
      }
    },
    async fetchNewsData() {
      try {
        const { data } = await this.$api.news.getNews(this.applicationPK);
        this.newsData = data.data;

        setTimeout(() => {
          this.popupActive = true;
        }, 2000);
      } catch (e) {
        console.log(e);
      }
    },
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    }
  }
};
</script>

<style lang="scss">
@import '~vue-slick-carousel/dist/vue-slick-carousel.css';
@import '~vue-slick-carousel/dist/vue-slick-carousel-theme.css';
@import '@/assets/scss/custom/components/variables';

.news-popup {
  .vs-popup {
    width: 1000px !important;

    .vs-popup--content {
      width: 100%;
      height: -webkit-fill-available;
      overflow: hidden;
      margin: 0 !important;
    }
  }

  .slick-slider {
    padding-inline: 50px;

    .slick-dots {
      position: initial;
      margin-bottom: 42px;

      li {

        &:hover,
        &.slick-active {
          button:before {
            color: $secondary;
          }
        }

        button:before {
          font-size: 15px;
        }
      }
    }

    .slick-prev,
    .slick-next {
      display: flex;
      justify-content: center;
      align-items: center;

      &:before {
        content: '';
      }
    }
  }

  .custom-prev,
  .custom-next {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    width: 50px;
    height: 50px;
  }

  .custom-prev {
    left: 10px;
  }

  .custom-next {
    right: 10px;
  }

  .custom-prev svg,
  .custom-next svg {
    width: 15px;
    height: 15px;
    padding: 10px;
    background: #{$secondary};
    color: black;
    border-radius: 20px;

    &:hover {
      -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);
      box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary), 1);
    }
  }
}
</style>